import { render, staticRenderFns } from "./create-folder.vue?vue&type=template&id=ac6084e0"
import script from "./create-folder.vue?vue&type=script&lang=js"
export * from "./create-folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports